import React from "react";
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Row, Col, Card, CardBody, CardTitle,
    Badge, Table
} from "reactstrap";

const PaymentAuditModal = ({ isOpen, toggle, payment }) => {
    if (!payment) return null;

    const formatDate = (dateString) => {
        if (!dateString) return "—";
        try {
            return new Date(dateString).toLocaleString('es-GT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return dateString;
        }
    };

    const getStatusBadge = (date) => {
        if (!date) return <Badge color="secondary">Sin fecha</Badge>;
        const validDate = new Date(date);
        const today = new Date();
        return validDate < today ? 
            <Badge color="danger">Expirado</Badge> : 
            <Badge color="success">Vigente</Badge>;
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="fa fa-history mr-2"></i>
                Auditoría de Pago - ID: {payment.id}
            </ModalHeader>
            <ModalBody>
                <Row>
                    {/* Payment Details */}
                    <Col md="6">
                        <Card className="mb-3">
                            <CardBody>
                                <CardTitle tag="h6" className="text-primary">
                                    <i className="fa fa-credit-card mr-2"></i>
                                    Detalles del Pago
                                </CardTitle>
                                <Table size="sm" borderless>
                                    <tbody>
                                        <tr>
                                            <td><strong>Cliente:</strong></td>
                                            <td>{payment.client || "—"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Plan:</strong></td>
                                            <td>
                                                <Badge color="info" pill>
                                                    {payment.membership?.name || "—"}
                                                </Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Monto:</strong></td>
                                            <td>
                                                <strong style={{ color: "#28a745" }}>
                                                    Q{(parseFloat(payment.amount) || 0).toFixed(2)}
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Método:</strong></td>
                                            <td>
                                                <Badge color={
                                                    payment.payment_method === 'Efectivo' ? 'success' :
                                                    payment.payment_method === 'Transferencia' ? 'primary' :
                                                    payment.payment_method === 'VisaLink' ? 'warning' : 'secondary'
                                                }>
                                                    {payment.payment_method || "—"}
                                                </Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Fecha de Pago:</strong></td>
                                            <td>{formatDate(payment.date_paid)}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Válido Hasta:</strong></td>
                                            <td>
                                                {formatDate(payment.valid_until)}
                                                <span className="ml-2">
                                                    {getStatusBadge(payment.valid_until)}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Audit Trail */}
                    <Col md="6">
                        <Card className="mb-3">
                            <CardBody>
                                <CardTitle tag="h6" className="text-info">
                                    <i className="fa fa-user-shield mr-2"></i>
                                    Registro de Auditoría
                                </CardTitle>
                                <Table size="sm" borderless>
                                    <tbody>
                                        <tr>
                                            <td><strong>Creado por:</strong></td>
                                            <td>
                                                <Badge color="primary">
                                                    {payment.created_by || "admin"}
                                                </Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Fecha de creación:</strong></td>
                                            <td>{formatDate(payment.created_at || payment.date_paid)}</td>
                                        </tr>
                                        {payment.modified_by && (
                                            <>
                                                <tr>
                                                    <td><strong>Modificado por:</strong></td>
                                                    <td>
                                                        <Badge color="warning">
                                                            {payment.modified_by}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Fecha de modificación:</strong></td>
                                                    <td>{formatDate(payment.updated_at)}</td>
                                                </tr>
                                            </>
                                        )}
                                        <tr>
                                            <td><strong>Última actualización:</strong></td>
                                            <td>{formatDate(payment.updated_at || payment.created_at || payment.date_paid)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Additional Information */}
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>
                                <CardTitle tag="h6" className="text-secondary">
                                    <i className="fa fa-info-circle mr-2"></i>
                                    Información Adicional
                                </CardTitle>
                                <Table size="sm" borderless>
                                    <tbody>
                                        <tr>
                                            <td><strong>Clases extra incluidas:</strong></td>
                                            <td>
                                                <Badge color="info">
                                                    {payment.extra_classes || 0} clases
                                                </Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>ID del Cliente:</strong></td>
                                            <td><code>{payment.client_id || "—"}</code></td>
                                        </tr>
                                        <tr>
                                            <td><strong>ID de Membresía:</strong></td>
                                            <td><code>{payment.membership?.id || "—"}</code></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                    style={{ backgroundColor: "#7F6552", color: "white", borderColor: "#7F6552" }}
                >
                    <i className="fa fa-times mr-1"></i>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentAuditModal;
